"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlVec3Uniform = void 0;
const a_gl_uniform_array_1 = require("./a-gl-uniform-array");
/**
 * @public
 * Wrapper for webgl float vector3 uniform.
 */
class GlVec3Uniform extends a_gl_uniform_array_1.AGlUniformArray {
    bind(renderer) {
        if (!this.isDirty) {
            return;
        }
        const data = this.data;
        renderer.context.uniform3fv(this.uniformLocation, data);
        this.isDirty = false;
    }
}
exports.GlVec3Uniform = GlVec3Uniform;
//# sourceMappingURL=gl-vec3-uniform.js.map